
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.25 4.583l-.516 8.355c-.132 2.134-.198 3.201-.733 3.969-.265.379-.605.7-1 .94-.8.486-1.868.486-4.007.486-2.141 0-3.212 0-4.011-.487a3.333 3.333 0 01-1-.942c-.536-.768-.6-1.837-.73-3.975L3.75 4.583M2.5 4.583h15m-4.12 0l-.57-1.173c-.377-.78-.566-1.17-.892-1.413a1.67 1.67 0 00-.229-.143c-.36-.187-.794-.187-1.66-.187-.888 0-1.332 0-1.7.195a1.667 1.667 0 00-.231.149c-.33.253-.514.657-.883 1.465l-.504 1.107M7.916 13.75v-5M12.084 13.75v-5","stroke":"#E50000","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    